import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcRestService} from 'exc-rest';

@Component({
  selector: 'modal-app-new-review-result',
  templateUrl: './modal-new-review-result.component.html',
  styles: []
})
export class ModalNewReviewResultComponent extends ExcTranslation implements OnInit {
  busy = false;
  reviewCodeIsOK = false;
  reviewCodeIsCritical = false;
  reviewCodeText;
  clID;
  language;

  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    _self.clID = _self.overlayConfig.data.clID;
    _self.language = _self.overlayConfig.data.cult;
  }

  save() {
    const _self = this;
        _self.overlayRef.close({proceed: true, obj: {
            mandantID: _self.clID,
            ReviewCodeText: _self.reviewCodeText,
            ReviewCodeCulture: _self.language,
            ReviewCodeIsOK: _self.generateBitValue(_self.reviewCodeIsOK),
            ReviewCodeIsCritical: _self.generateBitValue(_self.reviewCodeIsCritical)}});
  }

  toggleAuditCheckBoxes(name) {
    const _self = this;
    if (_self.reviewCodeIsOK && name === 'rIsOK') {
      _self.reviewCodeIsCritical = false;
    }
    if (_self.reviewCodeIsCritical && name === 'rIsCritical') {
      _self.reviewCodeIsOK = false;
    }
  }

  generateBitValue (val) {
    if (val === true) {
      return 1;
    } else {
      return 0;
    }
  }

}
